const colors = require("../styles/colors");

module.exports = {
  pathPrefix: "/",
  appName: "R01 - Reality Capture",
  siteTitle: "R01 - The reality capture platform",
  siteUrl: "https://reality01.com",
  siteImage: "preview.jpg",
  siteLanguage: "en",
  siteDescription: "R01 - we make it easy to turn real things in to studio quality 3D scans.",
  contactEmail: "hello@reality01.com",
  ctaLinkUrl: "https://reality01.com/",
  ctaLinkLabel: "Sign up",
  // manifest.json
  manifestName: "Reality Zero One",
  manifestShortName: "R01",
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.bg,
  manifestThemeColor: colors.bg,
  manifestDisplay: "standalone",
  // analytics
  analyticsTrackingId: "UA-92658016-1"
};



// WEBPACK FOOTER //
// ./src/utils/config.js